/**
 * Cross-page navigation helper for the hybrid SSR model. Each route is a real, server-rendered page,
 * so navigation performs a genuine browser navigation (which re-runs SSR and re-hydrates). The
 * navigation function is injectable purely so it can be asserted in tests without touching the real
 * `window.location`.
 */
export type NavigateFn = (path: string) => void;

export class Router {
  private readonly navigateFn: NavigateFn;

  constructor(navigateFn?: NavigateFn) {
    this.navigateFn = navigateFn ?? ((path) => window.location.assign(path));
  }

  /** The current pathname (e.g. "/lobby"). */
  get path(): string {
    return window.location.pathname;
  }

  /** Navigates to a same-origin path. No-op if already there. */
  navigate(path: string): void {
    if (path === this.path) {
      return;
    }
    this.navigateFn(path);
  }
}

/** Shared default router instance. */
export const router = new Router();
